module.exports = __webpack_public_path__ + "img/logo.8e1807b4.svg";